import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faMap, faChartLine, faChartBar, faChartPie, faPlus } from '@fortawesome/free-solid-svg-icons';
import FilterInsight from './FilterInsight';
import {
  getGrades,
  getKota,
  getSeri,
  getTahun,
  getTipe,
  getTransmisi,
  getSilinder,
  getMerk,
} from '../utils/Filter/FilterInsights';
import { cancelAddWidget } from '../services/amplitude';
import LIST_AUCTION_CITY from '../constant/auction-city';
import VEHICLE_YEAR from '../constant/vehicle-year';
import LIST_TRANSMISSION_VEHICLE from '../constant/transmission-vehicle';
import LIST_GRADE_VEHICLE from '../constant/grade-vehicle';
import LIST_BRAND_VEHICLE from '../constant/brand-vehicle';
import LIST_CYLINDER_VEHICLE from '../constant/cylinder-vehicle';
import LIST_SERIES_VEHICLE from '../constant/series-vehicle';
import LIST_TYPE_VEHICLE from '../constant/type-vehicle';

const InsightModal = ({ data, addWidget, editWidget }) => {
  const getTypeChart = (type) => {
    switch (type) {
      case 0:
        return 'line';
      case 1:
        return 'bar';
      case 2:
        return 'pie';
      case 3:
        return 'table';
      case 4:
        return 'map';
    }
  };

  const onRemove = ({ id }) => {
    let temp = filter;
    temp = filter.filter((item, i) => i !== id);
    setFilter(temp);

    temp = selected;
    temp = selected.filter((item, i) => i !== id);
    setSelected(temp);

    temp = option;
    temp = option.filter((item, i) => i !== id);
    setOption(temp);
  };

  const onChange = ({ event, id }) => {
    let temp_selected = [];
    let temp_option = [];

    switch (event.target.name) {
      case 'merk':
        getSeri(event.target.value).then((value) => {
          temp_selected = [...selected];
          temp_selected[id].brand = event.target.value;
          setSelected(temp_selected);

          temp_option = [...option];
          temp_option[id].series = value;
          setOption(temp_option);
        });
        break;

      case 'seri':
        getTipe(selected[id].brand, event.target.value).then((value) => {
          temp_selected = [...selected];
          temp_selected[id].series = event.target.value;
          setSelected(temp_selected);

          temp_option = [...option];
          temp_option[id].type = value;
          setOption(temp_option);
        });
        break;

      case 'tipe':
        getSilinder(selected[id].brand, selected[id].series, event.target.value).then((value) => {
          temp_selected = [...selected];
          temp_selected[id].type = event.target.value;
          setSelected(temp_selected);

          temp_option = [...option];
          temp_option[id].cylinder = value;
          setOption(temp_option);
        });
        break;

      case 'silinder':
        getTahun(selected[id].brand, selected[id].series, selected[id].type, event.target.value).then((value) => {
          temp_selected = [...selected];
          temp_selected[id].cylinder = event.target.value;
          setSelected(temp_selected);

          temp_option = [...option];
          temp_option[id].year = value;
          setOption(temp_option);
        });
        break;

      case 'tahun':
        getKota(
          selected[id].brand,
          selected[id].series,
          selected[id].type,
          selected[id].cylinder,
          event.target.value
        ).then((value) => {
          temp_selected = [...selected];
          temp_selected[id].year = event.target.value;
          setSelected(temp_selected);

          temp_option = [...option];
          temp_option[id].city = value;
          setOption(temp_option);
        });
        break;

      case 'kota':
        getTransmisi(
          selected[id].brand,
          selected[id].series,
          selected[id].type,
          selected[id].cylinder,
          selected[id].year,
          event.target.value
        ).then((value) => {
          temp_selected = [...selected];
          temp_selected[id].city = event.target.value;
          setSelected(temp_selected);

          temp_option = [...option];
          temp_option[id].transmission = value;
          setOption(temp_option);
        });
        break;

      case 'transmisi':
        getGrades(selected[id].brand, selected[id].city).then((value) => {
          temp_selected = [...selected];
          temp_selected[id].transmission = event.target.value;
          temp_selected[id].grade = '';
          setSelected(temp_selected);

          temp_option = [...option];
          temp_option[id].grade = value;
          setOption(temp_option);
        });

      case 'grade':
        temp_selected = [...selected];
        temp_selected[id].grade = event.target.value;
        setSelected(temp_selected);
    }
  };

  const [chart, setChart] = useState(data !== undefined ? getTypeChart(data.chartType) : '');
  const [selected, setSelected] = useState(
    data !== undefined
      ? data.filters
      : [
        {
          brand: '',
          series: '',
          cylinder: '',
          type: '',
          transmission: '',
          year: '',
          city: '',
          grade: '',
        },
      ]
  );

  const [option, setOption] = useState(
    data !== undefined
      ? Array(data.filters.length)
        .fill()
        .map((_, i) => ({
          brand: [],
          series: [],
          cylinder: [],
          type: [],
          transmission: [],
          year: [],
          city: [],
          grade: [],
        }))
      : [
        {
          brand: [],
          series: [],
          cylinder: [],
          type: [],
          transmission: [],
          year: [],
          city: [],
          grade: [],
        },
      ]
  );

  const [filter, setFilter] = useState(
    data !== undefined
      ? Array(data.filters.length)
        .fill()
        .map((_, i) => i)
      : [0]
  );
  const [metric, setMetric] = useState(data !== undefined ? data.metric : '');
  const [periode, setPeriode] = useState(data !== undefined ? data.period : '');
  const [nama, setNama] = useState(data !== undefined ? data.name : '');

  // all the brand is mandatory
  function brandSelected() {
    return selected.some((item) => item.brand === '') || selected.some((item) => item.brand === 'label');
  }

  function buttonDisabling() {
    if (metric === '' || periode === '' || chart === '' || brandSelected()) {
      return true;
    } else return false;
  }

  const onAddFilter = () => {
    const temp_selected = {
      brand: '',
      series: '',
      cylinder: '',
      type: '',
      transmission: '',
      year: '',
      city: '',
      grade: '',
    };
    const temp_option = {
      brand: [],
      series: [],
      cylinder: [],
      type: [],
      transmission: [],
      year: [],
      city: [],
      grade: [],
    };

    setFilter((oldValue) => [...oldValue, filter.length]);
    setSelected((oldValue) => [...oldValue, temp_selected]);
    setOption((oldValue) => [...oldValue, temp_option]);
  };

  const getChartType = (chart) => {
    switch (chart) {
      case 'line':
        return 0;
      case 'bar':
        return 1;
      case 'pie':
        return 2;
      case 'table':
        return 3;
      case 'map':
        return 4;
    }
  };

  const onAddChart = () => {
    var now = new Date();
    let id = '';
    id += now.getFullYear().toString();
    id += now.getMonth().toString();
    id += now.getDate().toString();
    id += now.getHours().toString();
    id += now.getMinutes().toString();
    id += now.getSeconds().toString();

    let temp_filter = selected.map((filter) => ({
      cylinder:
        LIST_CYLINDER_VEHICLE.filter(
          (cylinder) => cylinder.value == (filter.hasOwnProperty('cylinder') ? filter.cylinder : '')
        ).length == 1
          ? LIST_CYLINDER_VEHICLE.filter(
            (cylinder) => cylinder.value == (filter.hasOwnProperty('cylinder') ? filter.cylinder : '')
          )[0].key
          : filter.cylinder,
      brand:
        LIST_BRAND_VEHICLE.filter((brand) => brand.value == (filter.hasOwnProperty('brand') ? filter.brand : '')).length == 1
          ? LIST_BRAND_VEHICLE.filter((brand) => brand.value == (filter.hasOwnProperty('brand') ? filter.brand : ''))[0].key
          : filter.brand,
      city:
        LIST_AUCTION_CITY.filter((city) => city.value == (filter.hasOwnProperty('city') ? filter.city : '')).length == 1
          ? LIST_AUCTION_CITY.filter((city) => city.value == (filter.hasOwnProperty('city') ? filter.city : ''))[0].key
          : filter.city,
      grade:
        LIST_GRADE_VEHICLE.filter((grade) => grade.value == (filter.hasOwnProperty('grade') ? filter.grade : '')).length == 1
          ? LIST_GRADE_VEHICLE.filter((grade) => grade.value == (filter.hasOwnProperty('grade') ? filter.grade : ''))[0].key
          : filter.grade,
      series:
        LIST_SERIES_VEHICLE.filter((series) => series.value == (filter.hasOwnProperty('series') ? filter.series : ''))
          .length == 1
          ? LIST_SERIES_VEHICLE.filter((series) => series.value == (filter.hasOwnProperty('series') ? filter.series : ''))[0]
            .key
          : filter.series,
      transmission:
        LIST_TRANSMISSION_VEHICLE.filter(
          (transmission) => transmission.value == (filter.hasOwnProperty('transmission') ? filter.transmission : '')
        ).length == 1
          ? LIST_TRANSMISSION_VEHICLE.filter(
            (transmission) => transmission.value == (filter.hasOwnProperty('transmission') ? filter.transmission : '')
          )[0].key
          : filter.transmission,
      type:
        LIST_TYPE_VEHICLE.filter((type) => type.value == (filter.hasOwnProperty('type') ? filter.type : '')).length == 1
          ? LIST_TYPE_VEHICLE.filter((type) => type.value == (filter.hasOwnProperty('type') ? filter.type : ''))[0].key
          : filter.type,
      year:
        VEHICLE_YEAR.filter((year) => year.value == (filter.hasOwnProperty('year') ? filter.year : '')).length == 1
          ? VEHICLE_YEAR.filter((year) => year.value == (filter.hasOwnProperty('year') ? filter.year : ''))[0].key
          : filter.year,
    }));

    addWidget({
      name: nama,
      id: id,
      chartType: getChartType(chart),
      metric: metric,
      period: periode,
      filters: temp_filter,
    });
  };

  const onEditChart = () => {
    let temp_filter = selected.map((filter) => ({
      cylinder:
        LIST_CYLINDER_VEHICLE.filter(
          (cylinder) => cylinder.value == (filter.hasOwnProperty('cylinder') ? filter.cylinder : '')
        ).length == 1
          ? LIST_CYLINDER_VEHICLE.filter(
            (cylinder) => cylinder.value == (filter.hasOwnProperty('cylinder') ? filter.cylinder : '')
          )[0].key
          : filter.cylinder,
      brand:
        LIST_BRAND_VEHICLE.filter((brand) => brand.value == (filter.hasOwnProperty('brand') ? filter.brand : '')).length == 1
          ? LIST_BRAND_VEHICLE.filter((brand) => brand.value == (filter.hasOwnProperty('brand') ? filter.brand : ''))[0].key
          : filter.brand,
      city:
        LIST_AUCTION_CITY.filter((city) => city.value == (filter.hasOwnProperty('city') ? filter.city : '')).length == 1
          ? LIST_AUCTION_CITY.filter((city) => city.value == (filter.hasOwnProperty('city') ? filter.city : ''))[0].key
          : filter.city,
      grade:
        LIST_GRADE_VEHICLE.filter((grade) => grade.value == (filter.hasOwnProperty('grade') ? filter.grade : '')).length == 1
          ? LIST_GRADE_VEHICLE.filter((grade) => grade.value == (filter.hasOwnProperty('grade') ? filter.grade : ''))[0].key
          : filter.grade,
      series:
        LIST_SERIES_VEHICLE.filter((series) => series.value == (filter.hasOwnProperty('series') ? filter.series : ''))
          .length == 1
          ? LIST_SERIES_VEHICLE.filter((series) => series.value == (filter.hasOwnProperty('series') ? filter.series : ''))[0]
            .key
          : filter.series,
      transmission:
        LIST_TRANSMISSION_VEHICLE.filter(
          (transmission) => transmission.value == (filter.hasOwnProperty('transmission') ? filter.transmission : '')
        ).length == 1
          ? LIST_TRANSMISSION_VEHICLE.filter(
            (transmission) => transmission.value == (filter.hasOwnProperty('transmission') ? filter.transmission : '')
          )[0].key
          : filter.transmission,
      type:
        LIST_TYPE_VEHICLE.filter((type) => type.value == (filter.hasOwnProperty('type') ? filter.type : '')).length == 1
          ? LIST_TYPE_VEHICLE.filter((type) => type.value == (filter.hasOwnProperty('type') ? filter.type : ''))[0].key
          : filter.type,
      year:
        VEHICLE_YEAR.filter((year) => year.value == (filter.hasOwnProperty('year') ? filter.year : '')).length == 1
          ? VEHICLE_YEAR.filter((year) => year.value == (filter.hasOwnProperty('year') ? filter.year : ''))[0].key
          : filter.year,
    }));

    editWidget({
      name: nama,
      id: data.id,
      chartType: getChartType(chart),
      metric: metric,
      period: periode,
      filters: temp_filter,
    });
  };

  useEffect(() => {
    let temp_option = option;
    let temp_selecteds = selected;

    temp_selecteds = temp_selecteds.map((temp_selected) => ({
      cylinder:
        LIST_CYLINDER_VEHICLE.filter(
          (cylinder) => cylinder.key == (temp_selected.hasOwnProperty('cylinder') ? temp_selected.cylinder : '')
        ).length === 1
          ? LIST_CYLINDER_VEHICLE.filter(
            (cylinder) => cylinder.key == (temp_selected.hasOwnProperty('cylinder') ? temp_selected.cylinder : '')
          )[0].value
          : temp_selected.cylinder,
      brand:
        LIST_BRAND_VEHICLE.filter((brand) => brand.key == (temp_selected.hasOwnProperty('brand') ? temp_selected.brand : ''))
          .length === 1
          ? LIST_BRAND_VEHICLE.filter(
            (brand) => brand.key == (temp_selected.hasOwnProperty('brand') ? temp_selected.brand : '')
          )[0].value
          : temp_selected.brand,
      city:
        LIST_AUCTION_CITY.filter((city) => city.key == (temp_selected.hasOwnProperty('city') ? temp_selected.city : ''))
          .length === 1
          ? LIST_AUCTION_CITY.filter(
            (city) => city.key == (temp_selected.hasOwnProperty('city') ? temp_selected.city : '')
          )[0].value
          : temp_selected.city,
      grade:
        LIST_GRADE_VEHICLE.filter((grade) => grade.key == (temp_selected.hasOwnProperty('grade') ? temp_selected.grade : ''))
          .length === 1
          ? LIST_GRADE_VEHICLE.filter(
            (grade) => grade.key == (temp_selected.hasOwnProperty('grade') ? temp_selected.grade : '')
          )[0].value
          : temp_selected.grade,
      series:
        LIST_SERIES_VEHICLE.filter(
          (series) => series.key == (temp_selected.hasOwnProperty('series') ? temp_selected.series : '')
        ).length === 1
          ? LIST_SERIES_VEHICLE.filter(
            (series) => series.key == (temp_selected.hasOwnProperty('series') ? temp_selected.series : '')
          )[0].value
          : temp_selected.series,
      transmission:
        LIST_TRANSMISSION_VEHICLE.filter(
          (transmission) =>
            transmission.key == (temp_selected.hasOwnProperty('transmission') ? temp_selected.transmission : '')
        ).length === 1
          ? LIST_TRANSMISSION_VEHICLE.filter(
            (transmission) =>
              transmission.key == (temp_selected.hasOwnProperty('transmission') ? temp_selected.transmission : '')
          )[0].value
          : temp_selected.transmission,
      type:
        LIST_TYPE_VEHICLE.filter((type) => type.key == (temp_selected.hasOwnProperty('type') ? temp_selected.type : ''))
          .length === 1
          ? LIST_TYPE_VEHICLE.filter(
            (type) => type.key == (temp_selected.hasOwnProperty('type') ? temp_selected.type : '')
          )[0].value
          : temp_selected.type,
      year:
        VEHICLE_YEAR.filter((year) => year.key == (temp_selected.hasOwnProperty('year') ? temp_selected.year : ''))
          .length === 1
          ? VEHICLE_YEAR.filter(
            (year) => year.key == (temp_selected.hasOwnProperty('year') ? temp_selected.year : '')
          )[0].value
          : temp_selected.year,
    }));

    temp_option.map((item, i) => {
      let temp_selected = temp_selecteds[i];

      temp_selected = {
        cylinder:
          LIST_CYLINDER_VEHICLE.filter(
            (cylinder) => cylinder.key == (temp_selected.hasOwnProperty('cylinder') ? temp_selected.cylinder : '')
          ).length === 1
            ? LIST_CYLINDER_VEHICLE.filter(
              (cylinder) => cylinder.key == (temp_selected.hasOwnProperty('cylinder') ? temp_selected.cylinder : '')
            )[0].value
            : temp_selected.cylinder,
        brand:
          LIST_BRAND_VEHICLE.filter(
            (brand) => brand.key == (temp_selected.hasOwnProperty('brand') ? temp_selected.brand : '')
          ).length === 1
            ? LIST_BRAND_VEHICLE.filter(
              (brand) => brand.key == (temp_selected.hasOwnProperty('brand') ? temp_selected.brand : '')
            )[0].value
            : temp_selected.brand,
        city:
          LIST_AUCTION_CITY.filter((city) => city.key == (temp_selected.hasOwnProperty('city') ? temp_selected.city : ''))
            .length === 1
            ? LIST_AUCTION_CITY.filter(
              (city) => city.key == (temp_selected.hasOwnProperty('city') ? temp_selected.city : '')
            )[0].value
            : temp_selected.city,
        grade:
          LIST_GRADE_VEHICLE.filter(
            (grade) => grade.key == (temp_selected.hasOwnProperty('grade') ? temp_selected.grade : '')
          ).length === 1
            ? LIST_GRADE_VEHICLE.filter(
              (grade) => grade.key == (temp_selected.hasOwnProperty('grade') ? temp_selected.grade : '')
            )[0].value
            : temp_selected.grade,
        series:
          LIST_SERIES_VEHICLE.filter(
            (series) => series.key == (temp_selected.hasOwnProperty('series') ? temp_selected.series : '')
          ).length === 1
            ? LIST_SERIES_VEHICLE.filter(
              (series) => series.key == (temp_selected.hasOwnProperty('series') ? temp_selected.series : '')
            )[0].value
            : temp_selected.series,
        transmission:
          LIST_TRANSMISSION_VEHICLE.filter(
            (transmission) =>
              transmission.key == (temp_selected.hasOwnProperty('transmission') ? temp_selected.transmission : '')
          ).length === 1
            ? LIST_TRANSMISSION_VEHICLE.filter(
              (transmission) =>
                transmission.key == (temp_selected.hasOwnProperty('transmission') ? temp_selected.transmission : '')
            )[0].value
            : temp_selected.transmission,
        type:
          LIST_TYPE_VEHICLE.filter((type) => type.key == (temp_selected.hasOwnProperty('type') ? temp_selected.type : ''))
            .length === 1
            ? LIST_TYPE_VEHICLE.filter(
              (type) => type.key == (temp_selected.hasOwnProperty('type') ? temp_selected.type : '')
            )[0].value
            : temp_selected.type,
        year:
          VEHICLE_YEAR.filter((year) => year.key == (temp_selected.hasOwnProperty('year') ? temp_selected.year : ''))
            .length === 1
            ? VEHICLE_YEAR.filter(
              (year) => year.key == (temp_selected.hasOwnProperty('year') ? temp_selected.year : '')
            )[0].value
            : temp_selected.year,
      };

      getMerk()
        .then((value) => {
          temp_option[i].brand = value;
        })
        .catch((err) => { });

      if (temp_selected.brand !== '') {
        getSeri(temp_selected.brand)
          .then((value) => {
            temp_option[i].series = value;
          })
          .catch((err) => { });
      }

      if (temp_selected.brand !== '' && temp_option[i].series !== '') {
        getTipe(temp_selected.brand, temp_selected.series)
          .then((value) => {
            temp_option[i].type = value;
          })
          .catch((err) => { });
      }

      if (temp_selected.brand !== '' && temp_selected.series !== '' && temp_selected.type !== '') {
        getSilinder(temp_selected.brand, temp_selected.series, temp_selected.type)
          .then((value) => {
            temp_option[i].cylinder = value;
          })
          .catch((err) => { });
      }

      if (
        temp_selected.brand !== '' &&
        temp_selected.series !== '' &&
        temp_selected.type !== '' &&
        temp_selected.cylinder !== ''
      ) {
        getTahun(temp_selected.brand, temp_selected.series, temp_selected.type, temp_selected.cylinder)
          .then((value) => {
            temp_option[i].year = value;
          })
          .catch((err) => { });
      }

      if (
        temp_selected.brand !== '' &&
        temp_selected.series !== '' &&
        temp_selected.type !== '' &&
        temp_selected.cylinder !== '' &&
        temp_selected.year !== ''
      ) {
        getKota(
          temp_selected.brand,
          temp_selected.series,
          temp_selected.type,
          temp_selected.cylinder,
          temp_selected.year
        )
          .then((value) => {
            temp_option[i].city = value;
          })
          .catch((err) => { });
      }

      if (
        temp_selected.brand !== '' &&
        temp_selected.series !== '' &&
        temp_selected.type !== '' &&
        temp_selected.cylinder !== '' &&
        temp_selected.year !== '' &&
        temp_selected.city !== ''
      ) {
        getTransmisi(
          temp_selected.brand,
          temp_selected.series,
          temp_selected.type,
          temp_selected.cylinder,
          temp_selected.year,
          selected[i].city
        )
          .then((value) => {
            temp_option[i].transmission = value;
          })
          .catch((err) => { });
      }

      if (temp_selected.brand !== '' && temp_selected.city !== '') {
        getGrades(temp_selected.brand, temp_selected.city)
          .then((value) => {
            temp_option[i].grade = value;
          })
          .catch((err) => { });
      }
    });

    setOption(temp_option);
    setSelected(temp_selecteds);
  }, []);

  return (
    <div
      className="modal fade"
      id={data === undefined ? 'modal-insight' : `modal-insight-${data.id}`}
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-center p-4" style={{ backgroundColor: '#82be2a' }}>
            <h6 className="modal-title text-light">{editWidget !== undefined ? 'EDIT WIDGET' : 'TAMBAH WIDGET'}</h6>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-12">
                <label style={{ fontSize: 10, fontWeight: 'bold' }}>NAMA WIDGET</label>
                <input
                  value={nama}
                  onChange={(event) => {
                    setNama(event.target.value);
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Masukan Nama Widget"
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12 d-flex flex-row w-100">
                <div className="w-100 btn-group">
                  <button
                    className="d-flex flex-column align-items-center btn btn-secondary justify-content-center"
                    onClick={() => {
                      setChart('line');
                    }}
                    style={{
                      width: '10vw',
                      height: 100,
                      backgroundColor: chart === 'line' ? '#82be2a' : '#eee',
                      color: chart !== 'line' ? '#5A5959' : '#ffffff',
                    }}
                  >
                    <FontAwesomeIcon className="mb-1" icon={faChartLine} />
                    <span>Lines</span>
                  </button>
                  <button
                    className="d-flex flex-column align-items-center btn btn-secondary justify-content-center"
                    onClick={() => {
                      setChart('bar');
                    }}
                    style={{
                      width: '10vw',
                      height: 100,
                      backgroundColor: chart === 'bar' ? '#82be2a' : '#eee',
                      color: chart !== 'bar' ? '#5A5959' : '#ffffff',
                    }}
                  >
                    <FontAwesomeIcon className="mb-1" icon={faChartBar} />
                    <span>Bar</span>
                  </button>
                  <button
                    className="d-flex flex-column align-items-center btn btn-secondary justify-content-center"
                    onClick={() => {
                      setChart('pie');
                    }}
                    style={{
                      width: '10vw',
                      height: 100,
                      backgroundColor: chart === 'pie' ? '#82be2a' : '#eee',
                      color: chart !== 'pie' ? '#5A5959' : '#ffffff',
                    }}
                  >
                    <FontAwesomeIcon className="mb-1" icon={faChartPie} />
                    <span>Pie</span>
                  </button>
                  <button
                    className="d-flex flex-column align-items-center btn btn-secondary justify-content-center"
                    onClick={() => {
                      setChart('table');
                    }}
                    style={{
                      width: '10vw',
                      height: 100,
                      backgroundColor: chart === 'table' ? '#82be2a' : '#eee',
                      color: chart !== 'table' ? '#5A5959' : '#ffffff',
                    }}
                  >
                    <FontAwesomeIcon className="mb-1" icon={faTable} />
                    <span>Table</span>
                  </button>
                  <button
                    className="d-flex flex-column align-items-center btn btn-secondary justify-content-center"
                    onClick={() => {
                      setChart('map');
                    }}
                    style={{
                      width: '10vw',
                      height: 100,
                      backgroundColor: chart === 'map' ? '#82be2a' : '#eee',
                      color: chart !== 'map' ? '#5A5959' : '#ffffff',
                    }}
                  >
                    <FontAwesomeIcon className="mb-1" icon={faMap} />
                    <span>Geo Map</span>
                  </button>
                </div>
              </div>
            </div>
            {chart === '' && (
              <p className="text-danger ml-3 mb-0">
                <small>Pilih salah satu tampilan chart</small>
              </p>
            )}
            <div className="row mt-3">
              <div className="col-md-6">
                <label style={{ fontSize: 10, fontWeight: 'bold' }}>TAMPILKAN DATA</label>
                <select
                  value={metric}
                  className="form-control"
                  onChange={(event) => {
                    setMetric(event.target.value);
                  }}
                >
                  <option value="">Metrik Data</option>
                  <option value="avg_price">Harga Rata Rata</option>
                  <option value="max_price">Harga Maksimum</option>
                  <option value="min_price">Harga Minimum</option>
                </select>
                {metric === '' && (
                  <p className="text-danger ml-3 mb-0">
                    <small>Pilih salah satu</small>
                  </p>
                )}
              </div>
              <div className="col-md-6">
                <label style={{ fontSize: 10, fontWeight: 'bold' }}>PERIODE LELANG</label>
                <select
                  value={periode}
                  className="form-control"
                  onChange={(event) => {
                    setPeriode(event.target.value);
                  }}
                >
                  <option value="">Periode Lelang</option>
                  <option value="1">1 Bulan</option>
                  <option value="2">2 Bulan</option>
                  <option value="3">3 Bulan</option>
                  <option value="4">4 Bulan</option>
                  <option value="5">5 Bulan</option>
                  <option value="6">6 Bulan</option>
                </select>
                {periode === '' && (
                  <p className="text-danger ml-3 mb-0">
                    <small>Pilih periode lelang</small>
                  </p>
                )}
              </div>
            </div>
            <div className="row px-3">
              {filter.map((item, i) => {
                return (
                  <FilterInsight
                    key={i}
                    id={i}
                    selected={selected[i]}
                    option={option[i]}
                    count={filter.length}
                    label={`FILTER ${i + 1}`}
                    onChange={onChange}
                    onRemove={onRemove}
                  />
                );
              })}
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <button
                  className="w-50 p-2"
                  style={{ borderStyle: 'dashed', backgroundColor: 'white' }}
                  onClick={onAddFilter}
                >
                  <FontAwesomeIcon className="mr-2" icon={faPlus} />
                  Tambah Filter
                </button>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              style={{ backgroundColor: '#f05377' }}
              onClick={() => cancelAddWidget()}
            >
              Tutup
            </button>
            {editWidget !== undefined ? (
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-primary"
                onClick={() => {
                  onEditChart();
                }}
                style={{ backgroundColor: '#82be2a' }}
                disabled={buttonDisabling()}
              >
                Simpan Perubahan
              </button>
            ) : (
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-primary"
                onClick={() => {
                  onAddChart();
                }}
                style={{ backgroundColor: '#82be2a' }}
                disabled={buttonDisabling()}
              >
                Simpan Perubahan
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsightModal;
